module.exports = __webpack_public_path__ + "static/raf-f1ad932caa9270fc80c13de60b3c705f.jpg";